'use es6';

import { MENU_NODE_UPDATE, MENU_NODE_UPDATE_PAGE_LINK_ID, MENU_NODE_REPLACE } from 'simple-menus-core/actions/ActionTypes';
import * as pagesSelectors from 'simple-menus-core/selectors/pages';
export function updateNode(id, updates) {
  return {
    type: MENU_NODE_UPDATE,
    updates,
    id
  };
}
export function updatePageLinkId(id, pageLinkId) {
  return (dispatch, getState) => {
    const state = getState();
    const page = pagesSelectors.getCachedPage(state, {
      pageLinkId
    });
    dispatch({
      type: MENU_NODE_UPDATE_PAGE_LINK_ID,
      id,
      page
    });
  };
}
export function replaceNode(id, nodeType) {
  return {
    type: MENU_NODE_REPLACE,
    id,
    nodeType
  };
}